import React from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { UserActions } from "../../../redux/actions/user.actions";
import { instructorActions } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import { translationConstants } from "../../../constants";
import CertificateDetails from "./CertificateDetails";

const RejectedCertificate = ({
  fileDetails,
  userID,
  userEmail,
  isInstructor,
  gridState,
  isGeneralUser,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onSubmit = (data) => {
    const status = {
      status: 1,
      comments: data.comment,
      ...(fileDetails?.id && { sportLevelId: fileDetails.id }),
    };
    const documentStatus = {
      userId: userID,
      userEmail: userEmail,
      documentStatuses: [status],
    };
    dispatch(UserActions.OpenAppRejModal(false));
    if (isInstructor) {
      dispatch(
        instructorActions.approveInstructorDocuments(
          documentStatus,
          gridState,
          userID
        )
      );
    } else if (isGeneralUser) {
      const documentStatusDataSend = {
        ...documentStatus,
        documentStatuses: [
          {
            ...status,
            documentTypeId: fileDetails.documentTypeId,
          },
        ],
      };
      dispatch(
        UserActions.approvedDocuments(documentStatusDataSend, gridState)
      );
    } else {
      dispatch(
        UserActions.approvedCertificate(documentStatus, gridState, userID)
      );
    }
  };
  return (
    <div>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {isGeneralUser
            ? t(translationConstants.REJECT_DOCUMENT)
            : t(translationConstants.REJECT_QUALIFICATION)}
        </p>
      </div>
      <p className="horizentalLine" />
      {fileDetails?.qualifications && (
        <CertificateDetails fileDetails={fileDetails} />
      )}
      <Form
        className="approvalCertificateDiv"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Form.Group className="form-group formgroupTextarea">
          <Form.Label className="Form-labels">
            {t(translationConstants.comments)}
          </Form.Label>
          <textarea
            className="commentInput"
            {...register("comment", {
              required: t(translationConstants.commentRequired), // Add a required validation rule and define the translation key
            })}
            id="comment"
            type="text"
          />
          {errors.comment && (
            <p className="errorText">{errors.comment.message}</p>
          )}
        </Form.Group>

        <button className="rejected-button" type="submit">
          {t(translationConstants.Reject)}
        </button>
      </Form>
    </div>
  );
};

export default RejectedCertificate;
